import React, { useContext } from 'react';

/* ========== Components ========== */
import MyEventCard from 'structures/components/Cards/MyEvent';
import { Container } from 'structures/layouts/Styles/Container.style';

/* ========== Import Context ========== */
import DataContext from 'contexts/DataContext';

export default function MyEventsPreview() {
  const { AllEvents } = useContext(DataContext);

  /* ========== New Component ========== */
  return (
    <Container padding="1rem 2rem">
      <h3 className="SidePane__title">My Events</h3>
      {AllEvents.filter((Event) => Event.hasAccess).map(
        ({ name, price, time, isHosted }) => (
          <MyEventCard
            key={name}
            title={name}
            time="Now"
            role="Host"
            ishosted={isHosted}
          />
        )
      )}
    </Container>
  );
}
